// # Copyright Mimic Networks, Inc. 2024
module.exports = {
  content: [
    "./app/views/**/*.html.erb",
    "./app/helpers/**/*.rb",
    "./app/assets/stylesheets/**/*.css",
    "./app/javascript/**/*.js",
  ],
  theme: {
    extend: {
      fontFamily: {
        sans: ["DM Sans", "sans-serif"],
      },
      colors: {
        mimic: {
          black: "#222121",
          "light-brown": "#DCC37E",
          white: "#FBFBFB",
        },
      },
    },
  },
};
